import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: localStorage.getItem('isLoggedIn') === 'true',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signedIn(state) {
      state.isAuthenticated = true;
      localStorage.setItem('isLoggedIn', 'true');
    },
    signedOut(state) {
      state.isAuthenticated = false;
      localStorage.removeItem('isLoggedIn');
    },
  },
  selectors: {
    selectIsAuthenticated: (state) => state.isAuthenticated,
  },
});

export const { signedIn, signedOut } = authSlice.actions;
export const { selectIsAuthenticated } = authSlice.selectors;
export default authSlice.reducer;
